module.exports = __webpack_public_path__ + "img/2016-03-12.e2faa0b3.jpg";